module.exports = __webpack_public_path__ + "img/case_one.31518274.png";